import { Fragment, useEffect, useState } from "react";
import CustomersFilesWidget from "./CustomersFilesWidget";
import MachineFilesWidget from "./MachineFilesWidget";
import NetworkDiagramWidget from "../NetworkDiagram/NetworkDiagramWidget";
import MachineGatewayWidget from "../NetworkGateway/MachinGatewayWidget";
import ServiceCallWidget from "../ServiceCalls/ServiceCallsGridWidget";
import MachineInfoWidget from "../MachineInfo/MachineInfoWidget";
import MachinePicturesWidget from "../MachinePictures/MachinePicturesWidget";
import ServiceReportsWidget from "../ServiceReports/ServiceReportsGridWidget";
import SupportCasesWidget2 from "../SupportCases2/SupportCasesGridWidget";
import DeviceListWidget from "../DeviceList/DeviceListGridWidget";
import SparePartsWidget from "../Spareparts/SparepartsWidget";
import RunTimeWidget from "../RunTimes/RunTimeWidget";

import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";

const MachineTabStrip = (props: any) => {
    const [selected, setSelected] = useState(0);
  
  const handleSelect = (e: any) => {
    setSelected(e.selected);
  };
    return (
        <div  className="tabstrip-container">
      <TabStrip
                selected={selected}
                onSelect={handleSelect}
                style={{ maxHeight: "100%" }}
                className="pp-tabstrip"
                keepTabsMounted={true}
      >
        <TabStripTab title="Customer Files">
          <CustomersFilesWidget id="101" header="Customer Files" />,
        </TabStripTab>
        <TabStripTab title="Network Diagram">
          <NetworkDiagramWidget
            id="200"
            header="Network Diagram"
            thumb={false}
          />
          ,
        </TabStripTab>
        <TabStripTab title="Remote Gateway">
          <MachineGatewayWidget id="104" header="Remote Gateway Information" />,
        </TabStripTab>
        <TabStripTab title="Assembly Devices">
          <DeviceListWidget id="800" header="Device in project" />,
        </TabStripTab>
        <TabStripTab title="Service Calls">
          <ServiceCallWidget id="300" header="Service Calls" />
        </TabStripTab>
        {/*<TabStripTab title="Support Cases">*/}
        {/*  <SupportCasesWidget id="700" header="Support Cases" />*/}
        {/*        </TabStripTab>*/}
                <TabStripTab title="Support Cases">
                    <SupportCasesWidget2 id="701" header="Support Cases" />
                </TabStripTab>
                <TabStripTab title="Archive Service Reports">
          <ServiceReportsWidget id="500" header="Archive Service Reports" />
        </TabStripTab>
        <TabStripTab title="Machine Files">
          <MachineFilesWidget id="900" header="Machine Files" />
        </TabStripTab>
        <TabStripTab title="Machine Info">
          <MachineInfoWidget id="901" header="Machine Info" />
        </TabStripTab>
        <TabStripTab title="Spare Parts">
          <SparePartsWidget id="903" header="Spare part links" />
        </TabStripTab>
        <TabStripTab title="Machine Pictures">
          <MachinePicturesWidget id="902" header="Machine Pictures" />{" "}
        </TabStripTab>
                <TabStripTab title="Assembly Device On/Run Time Totals">
                    <RunTimeWidget id="99999999" header="Assembly Device On/Run Time Totals" />
        </TabStripTab>
      </TabStrip>
    </div>
  );
};
export default MachineTabStrip;
